module.exports = __webpack_public_path__ + "img/truck-booking-active.548aff56.svg";